import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { LoadingService } from 'src/app/shared/components/loading/services/loading.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalErrorComponent } from 'src/app/shared/components/modal-error/modal-error.component';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private loading: LoadingService, private modalService: NgbModal, private router: Router) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (request.headers.get('X-Skip-ErrorInterceptor')) {
            return next.handle(request);
        } else {
            return next.handle(request).pipe(
                catchError((err) => {
                    
                    if (request.headers.get('X-Get-HttpError')) {
                        return throwError(() => {
                            if (err.error.validations?.length) {
                                return { message: err.error.validations[0].message };
                            } else {
                                return { message: 'Não foi possível carregar os dados.' };
                            }
                        });
                    }
                    if (err instanceof HttpErrorResponse && !request.url.includes('api/tokens')) {
                        this.onError(err);
                    }
                    return throwError(err);
                })
            );
        }
    }

    onError(response: HttpErrorResponse): void {
        this.loading.hide();

        if (response.error.status === 403) {
            const modalRef = this.modalService.open(ModalErrorComponent);
            modalRef.componentInstance.message = 'Você não possui permissão para acessar esta aplicação.';
            
        } else if (response.error.status === 'Unauthorized') {
            this.router.navigateByUrl('/');

        } else if (response.error?.validations?.length) {
            const modalRef = this.modalService.open(ModalErrorComponent);
            modalRef.componentInstance.message = response.error.validations[0].message;

        } else if (response.status === 504) {
            const modalRef = this.modalService.open(ModalErrorComponent);
            modalRef.componentInstance.message = 'Não foi possível carregar todos os dados. Tente novamente.';
        }
    }
}
